module.exports = __webpack_public_path__ + "static/media/book_dark.02f69828.jpeg";